import Markup from "../../markup"

const Preloader = () => {
    return(
        <Markup.Global.Preloader.PreloaderWrap>
            <Markup.Global.Preloader.PreloaderBody>
                <div></div>
            </Markup.Global.Preloader.PreloaderBody>
        </Markup.Global.Preloader.PreloaderWrap>
    )
}

export default Preloader